import "./DailyRouteAppLearnMoreModal.scss";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {
    closeModalFn: () => void;
};

type Feature = {
    icon: string;
    titleKey: string;
    descKey?: string;
};

const features: Feature[] = [
    {
        icon: "fad fa-route",
        titleKey: "daily_route_app_feature_route_management",
        descKey: "daily_route_app_feature_route_management_desc",
    },
    {
        icon: "fad fa-truck",
        titleKey: "daily_route_app_feature_delivery_tracking",
        descKey: "daily_route_app_feature_delivery_tracking_desc",
    },
    {
        icon: "fad fa-camera",
        titleKey: "daily_route_app_feature_photo_capture",
    },
    {
        icon: "fad fa-signature",
        titleKey: "daily_route_app_feature_signature_capture",
    },
    {
        icon: "fad fa-cloud-download",
        titleKey: "daily_route_app_feature_offline_sync",
        descKey: "daily_route_app_feature_offline_sync_desc",
    },
    {
        icon: "fad fa-fingerprint",
        titleKey: "daily_route_app_feature_biometric_auth",
        descKey: "daily_route_app_feature_biometric_auth_desc",
    },
    {
        icon: "fad fa-moon",
        titleKey: "daily_route_app_feature_dark_mode",
    },
];

export const DailyRouteAppLearnMoreModal = (props: Props) => {
    const closeModal = () => {
        props.closeModalFn();
    };

    const handleContactClick = () => {
        window.location.href = "mailto:support@orderwerks.com?subject=Daily%20Route%20App%20Inquiry";
    };

    return (
        <div className={"DailyRouteAppLearnMoreModal p-3"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between align-items-start"}>
                    <OwTitle leftIconName={"fad fa-mobile-alt"} title={"daily_route_app"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-3"}>
                <p className={"description"}>
                    <OwLabel title={"help_text_daily_route_app"} />
                </p>
            </div>

            <div className={"mt-3"}>
                <h5>
                    <OwLabel title={"features"} />
                </h5>
                <ul className={"feature-list"}>
                    {features.map((feature, index) => (
                        <li key={index} className={"feature-item"}>
                            <i className={`${feature.icon} feature-icon`} />
                            <div className={"feature-content"}>
                                <span className={"feature-title"}>
                                    <OwLabel title={feature.titleKey} />
                                </span>
                                {feature.descKey && (
                                    <span className={"feature-desc"}>
                                        <OwLabel title={feature.descKey} />
                                    </span>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className={"mt-4 d-flex justify-content-center"}>
                <OwButton
                    title={"daily_route_app_contact_us"}
                    leftIconClass={"fas fa-envelope"}
                    fn={handleContactClick}
                    className={"btn-primary"}
                />
            </div>
        </div>
    );
};

export default DailyRouteAppLearnMoreModal;
